import date from 'quasar/src/utils/date.js';;

export default {
  methods: {
    createDateFromUnixTimestamp(unixTimestamp) {
      return new Date(unixTimestamp * 1000);
    },
    formatTimestampAsFullDate(unixTimestamp, format = 'DD.MM.YYYY') {
      return date.formatDate(
        this.createDateFromUnixTimestamp(unixTimestamp),
        format,
      );
    },
    formatTimestampAsMonthShortYear(unixTimestamp) {
      return date.formatDate(
        this.createDateFromUnixTimestamp(unixTimestamp),
        'MM / YY',
      );
    },
    formatTimestampAsTime(unixTimestamp) {
      return date.formatDate(
        this.createDateFromUnixTimestamp(unixTimestamp),
        'HH:mm',
      );
    },
  },
};
